import {Validator} from '@/type/validation/result';
import {全角のみ, 半角カナ禁止, 必須入力, 日付書式} from '@/type/validation/validator';
import moment from 'moment';

export interface 譲受検索条件型 {
    部署コード: string;
    譲受日付FROM: 日付型;
    譲受日付TO: 日付型;
    メーカー名: string;
    商品名カナ: string;
    譲受医療機関コード: string;
    登録者コード: string;
}

export interface 譲受削除依頼型 {
    譲受SEQ: number;
    更新バージョン: number;
}

export interface 譲受修正依頼型 {
    譲受修正一覧: 譲受修正型[];
    譲受先部署: string;
}

export interface 譲受修正型 {
    譲受確定対象: string;
    譲受SEQ: number;
    譲受伝票番号: string;
    譲受伝票行番号: number;
    更新バージョン: number;
    譲受医療機関コード: string;
    譲受担当薬剤師: string;
    商品コード: string;
    有効期限: 日付型;
    ロット番号: string;
    譲受数: number;
    譲受単価: number;
    バラ単位区分: string;
    譲受金額: number;
    譲受日付: 日付型;
    備考: string;
    登録者氏名: string;
    商品名: string;
    規格容量: string;
    メーカー名: string;
    包装単位名: string;
    包装数量単位名: string;
    修正前譲受: 修正前譲受型;
}

export interface 修正前譲受型 {
    譲受医療機関コード: string;
    譲受担当薬剤師: string;
    有効期限: 日付型;
    ロット番号: string;
    譲受数: number;
    譲受単価: number;
    バラ単位区分: string;
    譲受日付: 日付型;
    備考: string;
}

export type 日付型 = Date | null;

export interface 譲受修正検索結果型 {
    譲受修正一覧: 譲受修正型[];
    アラートメッセージ: string;
}

function 値は小数点3桁以下(value: number): boolean {
    const numbers = String(value).split('.');
    const length = (numbers[1]) ? numbers[1].length : 0;
    return length <= 3;
}

export function 数値必須入力(value: number): boolean {
    if (value === null) {
        return false;
    }
    return true;
}

function 値は0より大きい(value: number): boolean {
    if (value === null) {
        return true;
    }
    return value > 0;
}

function 未来日時は不可(value: Date): boolean {
    if (value === null) {
        return true;
    }
    const momentValue = moment(value);
    const momentNow = moment(new Date());
    return momentValue.isBefore(momentNow);
}

// バリデーション用のマップ
export const 譲受検索条件バリデータ一覧: Validator[] = [
    {
        name: '譲受日付FROM',
        constraints: [
            {method: 必須入力, message: '譲受年月日Fromは入力必須項目です'},
            {method: 日付書式, message: '譲受年月日Fromの書式を正しく入力してください'},
        ],
    },
    {
        name: '譲受日付TO',
        constraints: [
            {method: 日付書式, message: '譲受年月日Toの書式を正しく入力してください'},
        ],
    },
    {
        name: '商品名カナ',
        constraints: [
            {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
        ],
    },
];
export const 譲受修正バリデータマップ一覧: Validator[] = [
    {
        name: '譲受数',
        constraints: [
            {method: 数値必須入力, message: '譲受数は入力必須項目です'},
            {method: 値は0より大きい, message: '譲受数は0より大きい値を入力してください'},
            {method: 値は小数点3桁以下, message: '譲受数は小数点3桁以内で入力してください'},
        ],
    },
    {
        name: 'バラ単位区分',
        constraints: [
            {method: 必須入力, message: '単位名は入力必須項目です'},
        ],
    },
    {
        name: '譲受単価',
        constraints: [
            {method: 数値必須入力, message: '譲受単価は入力必須項目です'},
            {method: 値は0より大きい, message: '譲受単価は0より大きい値を入力してください'},
            {method: 値は小数点3桁以下, message: '譲受単価は小数点3桁以内で入力してください'},
        ],
    },
    {
        name: '譲受日付',
        constraints:  [
            {method: 必須入力, message: '譲受年月日は入力必須項目です'},
            {method: 日付書式, message: '譲受年月日の書式を正しく入力してください'},
            {method: 未来日時は不可, message: '譲受年月日は未来の日付への入力はできません'},
        ],
    },
    {
        name: '譲受医療機関コード',
        constraints:  [
            {method: 必須入力, message: '譲受医療機関は入力必須項目です'},
        ],
    },
    {
        name: '譲受担当薬剤師',
        constraints: [
            {method: 必須入力, message: '担当薬剤師は入力必須項目です'},
            {method: 全角のみ, message: '担当薬剤師に半角が含まれています'},
        ],
    },
];

